module.exports = __webpack_public_path__ + "static/media/ben.77b2976b.jpg";